"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserThreadType = void 0;
exports.threadIsSynthetic = threadIsSynthetic;
var UserThreadType;
(function (UserThreadType) {
    UserThreadType["Synthetic"] = "S"; // derived from post
})(UserThreadType || (exports.UserThreadType = UserThreadType = {}));
function threadIsSynthetic(thread) {
    return thread.type === UserThreadType.Synthetic;
}
